import { localizedLegalPage } from "./localized";
import { DpaPage as Fr } from "./fr/DpaPage";
import { DpaPage as En } from "./en/DpaPage";

export const DpaPage = localizedLegalPage({ fr: Fr, en: En });

export default DpaPage;
